import { Card, Col, Empty, Form, InputNumber, Row, Tooltip } from "antd";

/**
 * @param {Object} props
 * @param {import("./types").DefectCategory[]} props.categories
 * @param {boolean} props.loading
 * @param {boolean} [props.disabled]
 */
const DefectInputs = ({ categories, loading, disabled }) => {
  if (!loading && !categories.length) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No active defect categories configured" />;
  }

  return (
    <Row gutter={[8, 8]}>
      {categories.map((category) => (
        <Col key={category.id} xs={24} sm={12} md={8} lg={6}>
          <Card size="small" className="fi-defect-card" title={category.name} loading={loading}>
            <Row gutter={6}>
              {category.subcategories.map((sub) => (
                <Col key={sub.id} span={6}>
                  <Form.Item
                    name={["defects", String(sub.id)]}
                    label={
                      <Tooltip title={sub.description || ""}>
                        <span>{sub.name}</span>
                      </Tooltip>
                    }
                    style={{ marginBottom: 0 }}
                  >
                    <InputNumber size="small" min={0} precision={0} step={1} disabled={disabled} style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
              ))}
            </Row>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default DefectInputs;
